<template>
  <b-container class="mt-4">
    <b-row>
      <b-col cols="8" class="pb-5">
        <section>
          <h1 class="titulo-contato">{{ title }}</h1>
          <div  class="d-flex align-items-center col-10">
            <ContactForm />
          </div>
        </section>
      </b-col>
    </b-row>

  </b-container>
</template>

<script>
import ContactForm from '@/components/form/ContactForm';

export default {
  name: 'Contact',
  components: {
    ContactForm,
  },
  data() {
    return {
      title: 'Contato',
    };
  },
};
</script>

<style lang="scss" scoped>
  h1 {
      font: 21px $font-1;
      font-weight: 100;
      color: #88765A;
      margin: 0;
      padding-top: 40px;
      padding-bottom: 20px;
      padding-left: 15px;
    }
</style>
